import MssqlTaskRestService from '../rest/MssqlTaskRestService'

class MssqlTaskService {
  static async getStatus() {
    return MssqlTaskRestService.getStatus()
  }
}

export default MssqlTaskService
